var variables = require(process.env.themeFolder);

require([
    'jquery',
    'swiper',
    '@fancyapps/fancybox'
],
function($, SwiperModule, fancybox) {
    var Swiper = SwiperModule.default || SwiperModule;
    var Navigation = SwiperModule.Navigation;
    var Controller = SwiperModule.Controller;
    
    if (Swiper.use) {
        Swiper.use([Navigation, Controller]);
    }
    
    $(document).ready(function () {
        var imageCount = $('.images-wrapper').data('imagecount');
        var galleryThumbs, galleryTop;
        
        if (imageCount > 1 && $('.gallery-thumbs').length) {
            var swiperSettings = {
                loop: variables.galleryThumbsLoop,
                direction: variables.galleryThumbsDirection,
                spaceBetween: variables.galleryThumbsSpaceBetween,
                slidesPerView: variables.galleryThumbsSlidesPerView,
                touchRatio: 0.2,
                slideToClickedSlide: true,
                centeredSlides: variables.galleryThumbsCenteredSlides,
                freeMode: variables.galleryThumbsFreeMode,
                watchSlidesProgress: true,
                watchSlidesVisibility: true,
            };

            if (variables.galleryThumbsCenteredSlides === 'false') {
                swiperSettings.centeredSlides = false;
            }

            if (variables.galleryThumbsNavButtons === 'true') {
                $('.gallery-thumbs').append('<div class="swiper-button-next"></div><div class="swiper-button-prev"></div>');
                swiperSettings.navigation = {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                };
            }

            galleryThumbs = new Swiper('.gallery-thumbs', swiperSettings);
            
            setTimeout(function() {
                if (galleryThumbs.slides && galleryThumbs.slides.length <= galleryThumbs.params.slidesPerView) {
                    $('.gallery-thumbs .swiper-button-next, .gallery-thumbs .swiper-button-prev').hide();
                }
            }, 50);
            
            galleryThumbs.on('click', function() {
                if (galleryTop && galleryThumbs.clickedIndex !== undefined) {
                    galleryTop.slideTo(galleryThumbs.clickedIndex);
                }
            });
        }

        if (imageCount > 1 && $('.gallery-top').length) {
            var galleryTopSettings = {
                loop: variables.galleryTopLoop,
                loopAdditionalSlides: variables.galleryThumbsSlidesPerView,
                spaceBetween: 0,
                centeredSlides: true,
                slidesPerView: 1,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                watchSlidesProgress: true,
                allowTouchMove: true,
            };
            
            $('.gallery').addClass('swiper-transition');

            if (imageCount < 2) {
                $('.swiper-wrapper').addClass('disabled');
                $('.swiper-pagination').addClass('disabled');
            }

            if (galleryThumbs && variables.galleryThumbsUseControl === 'false') {
                galleryTopSettings.thumbs = {
                    swiper: galleryThumbs
                };
            }

            galleryTop = new Swiper('.gallery-top', galleryTopSettings);
            
            setTimeout(function() {
                if (galleryTop.slides && galleryTop.slides.length <= 1) {
                    $('.gallery-top .swiper-button-next, .gallery-top .swiper-button-prev').hide();
                }
            }, 50);

            $(document).on('click touchend', '.fancybox-slide', function (event) {
                if (!$(event.target).hasClass('fancybox-image')) {
                    $.fancybox.close();
                }
            });

            $(document).on('beforeClose.fb', function () {
                var currentIndex = $.fancybox.getInstance().currIndex;
                galleryTop.slideTo(currentIndex);
            });

            if ((variables.galleryThumbsUseControl === undefined || variables.galleryThumbsUseControl === 'true') && 
                galleryTop && galleryThumbs) {
                galleryTop.controller.control = galleryThumbs;
                galleryThumbs.controller.control = galleryTop;
            }
            
            if (galleryTop && galleryThumbs) {
                galleryThumbs.on('tap', function() {
                    if (galleryThumbs.clickedIndex !== undefined && galleryThumbs.clickedIndex !== galleryTop.activeIndex) {
                        galleryTop.slideTo(galleryThumbs.clickedIndex);
                    }
                });
            }
        }
    });
});
